<template>
  <nav aria-label="breadcrumb" class="breadcrumb-container">
    <ol class="breadcrumb">
      <li v-for="(crumb, index) in breadcrumbs" :key="index" class="breadcrumb-item">
        <span>{{ crumb }}</span>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: "AppBreadcrumb",
  computed: {
    breadcrumbs() {
      // Mapeamento dos segmentos para os nomes amigáveis
      const mapping = {
        "gestao": "Gestão",
        "cadastros": "Cadastros",
        "pessoas-fisicas": "Pessoas Físicas",
        "pessoas-juridicas": "Pessoas Jurídicas",
        "categorias-de-planos": "Categorias de Planos",
        "categorias-de-produtos": "Categorias de Produtos",
        "convenios": "Convênios",
        "niveis-turmas": "Níveis de Turmas",
        "funcionarios": "Funcionários",
        "cargos-funcionarios": "Cargos de Funcionários",
        "tipos-planos": "Tipos de Planos",
        "planos-matriculas": "Planos de Matrículas",
        "operacional": "Operacional",
        "prospeccao": "Prospecções",
        "matriculas": "Matrículas",
        "posvendas": "Pós-vendas",
        "aulas-avulsas": "Aulas Avulsas",
        "saidas-animais": "Saídas de Animais",
        "avaliacoes": "Avaliações de Desempenho",
        "blocos": "Blocos de Questões",
        "questoes": "Questões",
        "opcoes": "Opções",
        "turmas-instrutor": "Turmas do Instrutor",
        "financeiro": "Financeiro",
        "parametros": "Parâmetros de Pagamentos",
        "planos-contas": "Planos de Contas",
        "contas-financeiras": "Contas Financeiras",
        "cobrancas": "Cobranças e Boletos",
        "politicas": "Políticas de Cobrança",
        "detalhar": "Detalhar",
        "registros-financeiros": "Registros Financeiros",
        "configuracoes": "Configurações",
        "usuarios": "Usuários",
        "perfis-de-usuarios": "Perfis de Usuários",
        "avaliacoes-desempenho": "Avaliações de Desempenho",
        "supervisoes": "Supervisões",
        "imprimir-recibo": "Imprimir Recibo",
        "aulas-reposicao": "Aulas de Reposição",
        "receitas-gerais": "Receitas Gerais",
        "receitas-planos": "Receitas Planos",
        "avaliacoes-periodos": "Períodos de Avaliações",
        "relatorios": "Relatórios",
        "despesas-pagas-por-vencimento": "Despesas Pagas por Vencimento",
        "extrato-mensalidades-matriculas": "Extrato de Matrículas e Mensalidades Recebidas",
        "alunos-por-turma": "Alunos por turma",
        "protocolos-queda": "Protocolos de Queda",
        "emarketing-respativos": "E-mail Marketing - Responsáveis Ativos",
        "emarketing-respinativos": "E-mail Marketing - Responsáveis Inativos",
        "entradas": "Entradas de Produtos",
        "vendas": "Vendas de Produtos",


      };

      // Função auxiliar para formatar o horário
      const formatarHorario = (horarioRaw) => {
        const horarioStr = horarioRaw.toString().padStart(6, '0'); // Garante 6 dígitos
        const horas = horarioStr.slice(0, 2);
        const minutos = horarioStr.slice(2, 4);
        return `${horas}:${minutos}`;
      };

      // Função auxiliar para formatar o dia da semana
      const formatarDiaSemana = (diaSemana) => {
        const dias = {
          "terca-feira": "Terça-feira",
          "sabado": "Sábado",
          "segunda-feira": "Segunda-feira",
          "quarta-feira": "Quarta-feira",
          "quinta-feira": "Quinta-feira",
          "sexta-feira": "Sexta-feira",
          "domingo": "Domingo"
        };
        const diaFormatado = dias[diaSemana.toLowerCase()] || diaSemana;
        return diaFormatado.charAt(0).toUpperCase() + diaFormatado.slice(1);
      };

      // Constrói o breadcrumb a partir do caminho
      const segments = this.$route.path.split('/').filter(segment => segment);
      const crumbs = [];
      segments.forEach(segment => {
        // Decodifica o segmento para tratar %7C como |
        const decodedSegment = decodeURIComponent(segment);

        if (decodedSegment.includes('|')) {
          // Divide o segmento decodificado em partes
          const [turmaId, diaSemana, horarioRaw, instrutorEncoded] = decodedSegment.split('|');

          // Formata cada parte
          const turma = `Turma: ${turmaId}`;
          const dia = formatarDiaSemana(diaSemana); // Usa a função para formatar o dia
          const horario = formatarHorario(horarioRaw); // Converte horário (ex.: 100000 -> 10:00)
          const instrutor = decodeURIComponent(instrutorEncoded); // Decodifica %2520 para espaço

          // Junta tudo com " > " como separador
          const formattedCrumb = `${turma} > ${dia} > ${horario} > ${instrutor}`;
          crumbs.push(formattedCrumb);
        } else {
          // Usa o mapeamento ou formata o segmento
          crumbs.push(mapping[segment.toLowerCase()] || segment.charAt(0).toUpperCase() + segment.slice(1));
        }
      });
      // Adiciona "Home" como primeiro item
      return ["Home", ...crumbs];
    }
  }
};
</script>

<style scoped>
.breadcrumb-container {
  text-align: right;
  margin-bottom: 1rem;
}
.breadcrumb {
  background: transparent;
  padding: 0;
  margin: 0;
}
.breadcrumb-item + .breadcrumb-item::before {
  content: ">";
  padding: 0 0.5rem;
  color: #6c757d;
}
</style>